<script setup lang="ts">
import { ref } from 'vue';
import { useRouter } from 'vue-router';

import Modal from '@/components/base/layout/Modal.vue';
import Header6 from '@/components/base/typography/Header6.vue';
import OnsiteOffer from '@/components/personalization/OnsiteOffer.vue';
import OnsiteOfferNewsletterSignup from '@/components/quiz/OnsiteOfferNewsletterSignup.vue';
import OnsiteOfferQuiz from '@/components/quiz/OnsiteOfferQuiz.vue';
import { useOnsiteOffer } from '@/composables/personalization/useOnsiteOffer';

const router = useRouter();

const { closeModal, config, rescindOffer } = useOnsiteOffer();

const currentStage = ref<'landing' | 'quiz' | 'newsletterSignup'>('landing');

function handleNewsletterSignupCompleted() {
  rescindOffer();
  router.push('/onsite-offer-quiz-results');
}
</script>

<template>
  <Modal
    v-if="config.initialScreen"
    breakpoint="sm"
    fullHeight
    :hasControls="false"
    :hasDefaultPadding="false"
    :isOpen="config.isOpen"
    :width="currentStage === 'landing' ? 'md:max-w-4xl' : 'md:max-w-2xl'"
    @handle-close="closeModal"
  >
    <template v-if="currentStage !== 'landing'" #header>
      <Header6 class="w-full mt-6 text-center" tag="p">Answer a few questions</Header6>
    </template>
    <template #body>
      <OnsiteOffer
        v-if="currentStage === 'landing'"
        :initialScreen="config.initialScreen"
        @close="closeModal"
        @cta-clicked="currentStage = 'quiz'"
      />
      <OnsiteOfferQuiz
        v-show="currentStage === 'quiz'"
        class="w-full mt-5 h-[580px] sm:h-[570px]"
        @quiz-completed="currentStage = 'newsletterSignup'"
      />
      <OnsiteOfferNewsletterSignup
        v-show="currentStage === 'newsletterSignup'"
        class="w-full mt-7 h-[572px] sm:h-[562px]"
        :couponToken="config.initialScreen.couponToken"
        @newsletter-signup-completed="handleNewsletterSignupCompleted"
        @back="currentStage = 'quiz'"
      />
    </template>
  </Modal>
</template>
